import React, { Component } from "react"
import { Link } from "react-router-dom"
import moment from "moment"
import { FAVORITE_TYPE } from "../FavoriteButton/const"
import Favorite, { FavoriteStar } from "../../components/FavoriteButton"
import * as imageAsset from "../../shared/images"
import "./productCard.scss"
import { SHARED_INSIGHTS_REPORT_TYPE } from "../../shared/constants"

const TopicLink = (props) => {
  let { type, data } = props

  if (!data || data.length === 0) return null
  return (
    <div className="topic-link">
      <span className="title">
        {type}
        {data.length > 1 ? "s" : ""}:
      </span>
      {data.slice(0, 6).map(({ name, slug }, i) => (
        <span key={i}>
          {!!i ? ", " : ""}
          <Link to={`/${type.toLowerCase()}/${slug}`}>{name}</Link>
          {i === 5 && data.length > 5 ? "..." : ""}
        </span>
      ))}
    </div>
  )
}

class ProductCard extends Component {
  constructor(props) {
    super(props)
  }

  _renderBottomIcon = () => {
    let { isPurchased, isSpecialAccess, canRequestAccess, free } = this.props

    if (isPurchased) {
      return (
        <div
          className="product-card-price has-access purchased"
          data-purchased={true}
        >
          <span>Purchased</span>
        </div>
      )
    } else if (isSpecialAccess && !isPurchased) {
      return (
        <div className="product-card-price has-access">
          <span className="glyphicon glyphicon-ok-sign" />
        </div>
      )
    } else if (free) {
      return <div className="free-ribbon">Free Report! </div>
    } else if (canRequestAccess) {
      return (
        <div className="product-card-price request">Available by Request</div>
      )
    }
    return null
  }

  _renderBackupImage = () => {
    let { proprietaryDataset } = this.props
    let backgroundImage = imageAsset.productFallbackBackground

    let productType, iconImage

    switch (proprietaryDataset) {
      case "DD":
      case "DrillDowns":
        productType = "Drilldown"
        iconImage =
          "https://s3.amazonaws.com/dev-etr/images/fallback/Drilldown.png"
        break
      case "ETS":
        productType = "ETS Report"
        iconImage =
          "https://s3.amazonaws.com/dev-etr/images/fallback/TSIS-PCAS.png"
        break
      case "TSIS":
        productType = "TSIS Report"
        iconImage =
          "https://s3.amazonaws.com/dev-etr/images/fallback/TSIS-PCAS.png"
        break
      case "VENN":
        iconImage = imageAsset.etrColorInsights
        break
      case "DataFiles":
        productType = "Data File"
        iconImage =
          "https://s3.amazonaws.com/dev-etr/images/fallback/TSIS-PCAS.png"
        break
      case "VEC":
        productType = "VEC Report"
        iconImage =
          "https://s3.amazonaws.com/dev-etr/images/fallback/TSIS-PCAS.png"
        break
      case "DataReport":
        productType = "Data Report"
        iconImage = "/static/images/data-report.png"
        return (
          <div className="no-image-full">
            <div
              className="image-link"
              style={{ backgroundImage: `url('${iconImage}')` }}
            />
          </div>
        )
      default:
        productType = "Report"
        iconImage =
          "https://s3.amazonaws.com/dev-etr/images/fallback/Drilldown.png"
    }

    return (
      <div
        className="no-image"
        style={{ backgroundImage: `url('${backgroundImage}')` }}
      >
        <span>{productType}</span>
        <div
          className="image-link"
          style={{ backgroundImage: `url('${iconImage}')` }}
        />
      </div>
    )
  }

  _renderDescriptionItems = () => {
    let { proprietaryDataset, vendor, sector, metadata } = this.props

    if (
      proprietaryDataset === "TSIS" ||
      proprietaryDataset === "ETS" ||
      proprietaryDataset === "DD"
    ) {
      return [
        <TopicLink type="Vendor" data={vendor} key={0} />,
        <TopicLink type="Sector" data={sector} key={1} />,
      ]
    }

    if (proprietaryDataset === "VENN" && metadata) {
      let detailItems = []

      if (metadata.Speakers) {
        detailItems.push(
          <div key={0} className="event-data Speakers">
            {(metadata.Speakers || [])
              .map(
                (speaker) =>
                  `${speaker["Speaker Name"]}, ${speaker["Speaker Title"]}`
              )
              .join(",\n")}
          </div>
        )
      }

      if (metadata.Organization) {
        detailItems.push(
          <div key={1} className="event-data">
            {metadata.Organization}
          </div>
        )
      }

      if (metadata["Event Date"]) {
        detailItems.push(
          <div key={2} className="event-data">
            {moment.utc(metadata["Event Date"]).format("MMM DD, YYYY")}
          </div>
        )
      }
      return detailItems
    }

    return null
  }

  render = () => {
    let {
      proprietaryDataset,
      slug,
      logo,
      showFavoriteIcon,
      name,
      files,
      onClickDatafiles,
      free,
    } = this.props

    if (proprietaryDataset === "DataFiles") {
      let canDownload = files && files.length > 0

      const onClick = (e) => {
        if (!canDownload) {
          e.preventDefault()
        } else {
          onClickDatafiles && onClickDatafiles()
        }
      }

      return (
        <a
          className={`product-card-container ${!canDownload && "no-pointer"}`}
          href={`/products/${slug[0]}`}
          download
          onClick={onClick}
        >
          <div className="product-card-image">
            {this._renderBackupImage()}
            {this._renderBottomIcon()}
          </div>
          <div className="product-card-description">
            <div className="product-card-title">
              <span>{name}</span>
            </div>
            <div className="data-files-download">
              {canDownload
                ? "Click to download"
                : "Not yet available for download"}
            </div>
          </div>
        </a>
      )
    }

    const isSharedInsightsProduct = (dataset) => {
      if (!dataset) return false

      return Object.keys(SHARED_INSIGHTS_REPORT_TYPE).includes(dataset)
    }

    return (
      <div
        className={`product-card-container ${free ? "free-product" : ""}`}
        data-cy="product-card-container"
      >
        <Link to={`/marketplace/${slug[0]}`} className="product-card-image">
          {logo ? (
            <div
              className="image"
              style={{ backgroundImage: `url('${logo}')` }}
            />
          ) : isSharedInsightsProduct(proprietaryDataset) ? (
            <div
              className="image"
              style={{
                backgroundImage: `url('${SHARED_INSIGHTS_REPORT_TYPE[proprietaryDataset].defaultImage}')`,
              }}
            />
          ) : (
            this._renderBackupImage()
          )}
          {this._renderBottomIcon()}
        </Link>

        <div className="product-card-description">
          <div className="product-card-title">
            <Link to={`/marketplace/${slug[0]}`}>{name}</Link>
          </div>
          {this._renderDescriptionItems()}
        </div>
        {showFavoriteIcon && !this.props.loading && this.props.isMyFavorite && (
          <Favorite
            favoriteData={{
              name: this.props.name,
              description: this.props.description,
              favoriteType:
                this.proprietaryDataset === "DataReport"
                  ? FAVORITE_TYPE.DATAREPORT
                  : "REPORT",
              slug: "/marketplace/" + slug[0],
              metadata: {
                imageURL:
                  proprietaryDataset == "VENN"
                    ? "/static/images/ETR-color-insights-logo.png"
                    : logo,
                productId: this.props.id,
              },
            }}
            location={this.props.location}
            variables={{ productId: this.props.id }}
            favoriteType="REPORT"
            trackingLocation="Market Place Product"
          >
            <FavoriteStar />
          </Favorite>
        )}
      </div>
    )
  }
}

export default ProductCard
